import { IRequestIO, IResponseIO } from '../core/adapter';
import { AdapterIO, IAdapterIO } from '../core/adapter';
import { dataRead, dataWrite } from '../helpers/raw_data';
import { TOptions } from '../core/interceptor';
import { t_adapter } from '../core/io';

import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export type RequestStorage = IRequestIO;
export type ResponseStorage = IResponseIO;

/**
 *
 */
export class StorageAdapterIO
  extends AdapterIO<RequestStorage, ResponseStorage, TOptions>
  implements IAdapterIO<RequestStorage, ResponseStorage, TOptions> {
  type = 'storage' as t_adapter;

  protected async _query(path: string, request: RequestStorage) {
    if (request.signal?.aborted) {
      return { data: null };
    }

    try {
      const [type, table] = path.indexOf('://') >= 0 ? path.split('://') : ['local', path];
      const storage = type === 'session' ? sessionStorage : localStorage;
      const data = request.data;

      if (f1.is.exists(data)) {
        storage.setItem(table, dataWrite(data));
      }

      const raw = storage.getItem(table);
      return {
        data: null == raw ? null : dataRead(raw)
      };
    } catch (e) {
      return {
        data: null
      };
    }
  }
}
